import React from "react";
import { postGDData, postGDAttachment } from "../Actions/GDNewEditItem";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { css } from "glamor";
import $ from "jquery";
toast.configure();
class GDNewItem extends React.Component {
    constructor(props) {  
        super(props);
        this.state = {
            GDPostArray: { companyName: '', attachmentName: '', attachmentGuid: '', createdBy: '' },
            file: '',
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.SubmitGDData = this.SubmitGDData.bind(this);
    }
    // static getDerivedStateFromProps(nextProps, prevState) {
    //     const { dispatch } = nextProps;
    //     if (nextProps.GDAttachmentData !== '' && nextProps.GDAttachmentData !== prevState.GDAttachmentData) {
    //         prevState.GDAttachmentData = nextProps.GDAttachmentData;
    //         prevState.GDPostArray.attachmentName = nextProps.GDAttachmentData.FileName;
    //         prevState.GDPostArray.attachmentGuid = nextProps.GDAttachmentData.Guid;
    //         prevState.GDPostArray.createdBy = nextProps.userDisplayName;
    //         dispatch(postGDData(prevState.GDPostArray));
    //     }
    //     if (nextProps.IsGDDataAdded && nextProps.IsGDDataAdded !== undefined) {
    //         nextProps.history.push('/Home/GDLibray');
    //         dispatch({type:"GDAttchmentClear"})
    //     }
    // }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { GDAttachmentData, dispatch } = nextProps;
        if (GDAttachmentData && GDAttachmentData !== "") {
            prevState.GDPostArray.attachmentName = GDAttachmentData.FileName;
            prevState.GDPostArray.attachmentGuid = GDAttachmentData.Guid;
            prevState.file = '';
            dispatch({ type: "GDAttchmentUploadSuccess", data: "" })
        }
    }

    CancelGD() {
        this.props.history.push('/Home/GDLibray');
    }


    handleInputChange(e) {
        let nodeName = e.target.name;
        if (nodeName === "fileName") {
            e.target.files[0].name.trim() !== "" ? $("#GDNFileNewErrMsg").text("") : $("#GDNFileNewErrMsg").text("This field is required");
            this.state.GDPostArray.attachmentName = e.target.files[0].name;
            this.state.file = e.target.files[0];
            this.setState({ GDPostArray: this.state.GDPostArray });
            this.props.dispatch(postGDAttachment(e.target.files[0]));
        } else {
            e.target?.value.trim() !== "" ?  $("#GDNNameNewErrMsg").text("") : $("#GDNNameNewErrMsg").text("This field is required");
            this.state.GDPostArray[nodeName] = e.target.value;
            this.setState({});
        }
    }

    // handleInputFileChange(e) {
    //     e.preventDefault();
    //     let file = e.target.files[0];
    //     this.state.GDPostArray.attachmentName = e.target.files[0].name;
    //     this.setState({ file: file });
    // }

    SubmitGDData() {
        const { dispatch, history } = this.props;
     

        if (this.state.GDPostArray.attachmentName.trim() == "" || this.state.GDPostArray.companyName.trim() == ""){
            this.state.GDPostArray.companyName.trim() == "" ? $("#GDNNameNewErrMsg").text("This field is required") : $("#GDNNameNewErrMsg").text("");
            this.state.GDPostArray.attachmentName.trim() == "" ? $("#GDNFileNewErrMsg").text("This field is required") : $("#GDNFileNewErrMsg").text("");
        } else {
            $("#GDNNameNewErrMsg").text("");
            $("#GDNFileNewErrMsg").text("");
            dispatch(postGDData(this.state.GDPostArray));
            history.push('/Home/GDLibray');
        }
    }

    ClearInput() {
        let clearData = { FileName: "", Guid: "" }
        this.props.dispatch({
            type: "GDAttchmentUploadSuccess",
            data: clearData,
        })
        $("#GDNFileNewErrMsg").text("This field is required")
    }

    render() {
        return (
            <div className="full-height w-100">
                <div className="grey-bg  course-list-page pt-3">
                    <div className="px-4">
                        <div className="panel-box search-filter-box mb-4">
                            <div className="row" style={{ paddingBottom: '12px' }}>
                                <div className="col-lg-6">
                                    <label className="form-label required" >Company Name</label><br></br>
                                    <input className="form-control" type="text" name="companyName" onChange={(e) => this.handleInputChange(e)} value={this.state.GDPostArray.companyName}></input>
                                    <span id="GDNNameNewErrMsg" className="spanErrMsg ml-2"></span>
                                </div>
                                <div className="col-lg-6">
                                    <label className="form-label required" >File</label><br></br>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">Browse File<input type="file"  style={{ marginRight: 40 }} id="files" title=" " name="fileName" onChange={(e) => this.handleInputChange(e)} /></span>
                                        </div>
                                        <input type="text" class="form-control" placeholder="No file chosen" value={this.state.GDPostArray.attachmentName} />
                                        {
                                            this.state.GDPostArray.attachmentName ?
                                                <div class="input-group-append" style={{cursor:"pointer"}}>
                                                    <i class="fa fa-times input-group-text" aria-hidden="true" onClick={() => this.ClearInput()}></i>
                                                </div> : ''
                                        }

                                    </div>
                                    <span id="GDNFileNewErrMsg" className="spanErrMsg ml-2"></span>
                                </div>

                                <div className="col-lg-12">
                                    <label className="form-label" ></label><br></br>
                                    <div className="search-btn-col" style={{ textAlign: 'end' }}>
                                        <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.SubmitGDData()}> Submit </button>

                                        <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.CancelGD()}> Cancel </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        GDAttachmentData: state.SidePanReducer.GDAttachmentData,
        userDisplayName: state.SidePanReducer.userDisplayName,
        IsGDDataAdded: state.SidePanReducer.IsGDDataAdded
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GDNewItem));